import { useMutation } from '@apollo/client';
import { isTokenExpired } from '@base/utility/TokenUtility';
import { CREATE_PUBLIC_TOKEN } from '@core/helpers/usePublicToken.query';
import useLocalStorage from '@vh/utility/useLocalStorage';
import { useEffect, useMemo, useState } from 'react';

export const usePublicToken = ({ skip } = {}) => {
  const [storedPublicTokenData] = useLocalStorage('public_token_data', '');
  // don't use stored data if token is expired
  const unexpiredPublicTokenData = useMemo(() => {
    if (!storedPublicTokenData) return null;
    if (isTokenExpired(storedPublicTokenData?.createPublicToken?.Token)) {
      return null;
    }
    return storedPublicTokenData;
  }, [storedPublicTokenData]);

  const [login, { data, loading, error, called }] = useMutation(
    CREATE_PUBLIC_TOKEN,
    {}
  );
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      if (skip || !!unexpiredPublicTokenData) {
        return;
      }
      const { data: loginData } = await login();
      let tokens = 0;

      if (loginData?.createPublicToken?.Token) {
        tokens = tokens + 1;
        localStorage.setItem(
          'public_token',
          JSON.stringify(loginData.createPublicToken.Token)
        );
        localStorage.setItem(
          'public_user_id',
          loginData?.createPublicToken?.Member?.ID
        );
      }
      if (loginData?.createPublicToken?.PDToken) {
        tokens = tokens + 1;
        localStorage.setItem(
          'public_ai_token',
          JSON.stringify(loginData.createPublicToken.PDToken)
        );
      }
      localStorage.setItem('public_token_data', JSON.stringify(loginData));

      if (tokens === 2) {
        setLoaded(true);
      }
    })();
  }, [login, skip, unexpiredPublicTokenData]);

  return {
    data: data ?? unexpiredPublicTokenData ?? null,
    loading: loading || (!loaded && !skip && !unexpiredPublicTokenData),
    error,
    valid: !!unexpiredPublicTokenData,
  };
};

export default usePublicToken;
